import { forwardRef, useCallback } from "react"
import { Typography } from "@mui/material"
import MuiAlert from "@mui/material/Alert"
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack"

const CustomSuccessSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  ({ id, message }, ref) => {
    const htmlTag = document.documentElement
    const dirAttribute = htmlTag.getAttribute("dir")
    const currentDirection = dirAttribute === "rtl" ? "rtl" : "ltr"
    const { closeSnackbar } = useSnackbar()
    const handleClose = useCallback(() => {
      closeSnackbar(id)
    }, [id, closeSnackbar])

    return (
      <SnackbarContent ref={ref}>
        <MuiAlert
          dir={currentDirection}
          severity='success'
          sx={{
            width: "100%",
            minWidth: 350,
            alignItems: "center",
            ".MuiAlert-message": { py: 0 },
            backgroundColor: "success.3",
          }}
          onClose={handleClose}
        >
          <Typography color='text.16'>{message}</Typography>
        </MuiAlert>
      </SnackbarContent>
    )
  },
)

CustomSuccessSnackbar.displayName = "CustomSuccessSnackbar"
export default CustomSuccessSnackbar
